var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.82 20.906-1.172-1.172 5-5h8.672v-10H3.68v10H7v1.68H2V3.094h20v13.32h-9.648L7.82 20.906Z",
    fill: "#141414"
  })));
};
export { SvgChat as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik03LjgyMDMxIDIwLjkwNjJMNi42NDg0NCAxOS43MzQ0TDExLjY0ODQgMTQuNzM0NEgyMC4zMjAzVjQuNzM0MzhIMy42Nzk2OVYxNC43MzQ0SDdWMTYuNDE0MUgyVjMuMDkzNzVIMjJWMTYuNDE0MUgxMi4zNTE2TDcuODIwMzEgMjAuOTA2MloiIGZpbGw9IiMxNDE0MTQiLz4KPC9zdmc+Cg==";